import type { CustomIconProps } from '../CustomIcon';

export const DocumentSlotIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M3 18V20C3 21.1046 3.89543 22 5 22H7'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path
        d='M3 6V4C3 2.89543 3.89543 2 5 2H7'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path
        d='M21 6V4C21 2.89543 20.1046 2 19 2H17'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path
        d='M21 18V20C21 21.1046 20.1046 22 19 22H17'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path
        d='M13.1875 5H8.375C8.01033 5 7.66059 5.1475 7.40273 5.41005C7.14487 5.6726 7 6.0287 7 6.4V17.6C7 17.9713 7.14487 18.3274 7.40273 18.5899C7.66059 18.8525 8.01033 19 8.375 19H16.625C16.9897 19 17.3394 18.8525 17.5973 18.5899C17.8551 18.3274 18 17.9713 18 17.6V9.9L13.1875 5Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13 5V10H18'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
